<template>
  <v-container fluid align-stretch>
    <div class="page-content">
      <v-navigation-drawer v-model="drawer2" width="340" absolute temporary :overlay-opacity="0">
        <devLeftSidebar />
      </v-navigation-drawer>

      <div class="dev-page-dashboard" @contextmenu="unselectComponent" @click.prevent="unselectComponent">
        <v-navigation-drawer
          v-model="drawer"
          absolute
          permanent
          left
          :width="leftDrawerWidth"
          :style="background"
          class="dev-step-two-v-navigation-drawer-left"
        >
          <v-app-bar v-if="!previewVisible" dense fixed tile elevation="1" max-height="47" color="grey lighten-4">
            <v-icon @click.stop="drawer2 = !drawer2" class="mr-4" title="Configurações de Telas">menu</v-icon>

            <v-overflow-btn
              flat
              dense
              v-model="mode"
              :items="modes"
              label="Modo de tela"
              hide-details
              class="select-modes"
              append-icon="zmdi zmdi-chevron-down"
              @change="changeModes"
              item-color="blue"
            ></v-overflow-btn>

            <v-spacer />

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon :disabled="disableActionClone" @click="clone" class="ml-4">filter_none</v-icon>
                </div>
              </template>

              <span>Clonar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon :disabled="disableActionRemove" @click="remove" class="ml-4">delete</v-icon>
                </div>
              </template>

              <span>Deletar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon :disabled="typeOfPageEditing === ''" @click="confirmSaveInFolder" class="ml-4">save</v-icon>
                </div>
              </template>

              <span>Salvar</span>
            </v-tooltip>
          </v-app-bar>

          <v-container
            v-if="selectedPage !== ''"
            fluid
            :class="['pb-4 d-flex flex-column', mode === 'list' ? 'pl-3 pr-2' : 'pl-2 pr-1', previewVisible ? 'pt-2' : 'pt-13']"
          >
            <component v-if="schema && renderComponent" :is="currentComponent" page="dev" :context="mode !== 'list' && mode" />
          </v-container>
        </v-navigation-drawer>

        <v-navigation-drawer
          v-if="selectedPage !== ''"
          v-model="drawer"
          absolute
          permanent
          right
          :width="rightDrawerWidth"
          class="dev-step-two-v-navigation-drawer-right"
        >
          <v-tabs v-model="tab" background-color="grey lighten-4" fixed-tabs class="elevation-1" color="grey darken-3" slider-color="grey darken-3">
            <v-tab href="#tab-1">
              <v-icon small class="mr-1">mdi-view-dashboard</v-icon>
              <span class="font-weight-bold text-capitalize">Componentes</span>
            </v-tab>

            <v-tab href="#tab-2" :disabled="!selectedComponent">
              <v-icon small class="mr-1">mdi-settings</v-icon>
              <span class="font-weight-bold text-capitalize">Configurações</span>
            </v-tab>

            <v-tab href="#tab-3">
              <v-icon small class="mr-1">build</v-icon>
              <span class="font-weight-bold text-capitalize">Geral</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" mandatory>
            <v-tab-item value="tab-1">
              <v-expansion-panels
                v-model="panel"
                class="accordion-list-components accordion-list-components__clean accordion-list-components__tab-1"
                accordion
                hover
                focusable
              >
                <v-expansion-panel v-for="(item, index) in accordions" :key="index" class="v-expansion-panel__clean">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === index" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3">{{ item.name }}</span>
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">{{ item.name }}</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="px-3 pt-2">
                    <v-row dense class="row-components">
                      <v-col class="mb-2" v-for="(children, i) in item.children" :key="i" sm="3" @click="handleRenderComponent(children)">
                        <v-icon v-text="children.icon" size="20"></v-icon>

                        <span v-text="children.name"></span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-tab-item>

            <v-tab-item value="tab-2" class="pt-3 pb-2">
              <vue-form-generator
                tag="div"
                v-if="selectedComponent"
                :schema="{ fields: selectedComponent.fields }"
                :model="selectedComponent.models"
                :options="{ mode, page: 'dev' }"
              />
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-expansion-panels v-model="panel" class="accordion-list-components accordion-list-components__clean" accordion hover focusable>
                <v-expansion-panel class="v-expansion-panel__clean">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === 0" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3"
                        >Procedure {{ mode }}</span
                      >
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">Procedure</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="px-2 py-3">
                    <v-text-field label="Procedure" v-model="schema[mode].procedure.name" dense color="grey darken-3" hide-details />
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="v-expansion-panel__clean">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === 1" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3"
                        >Conditions {{ mode }}</span
                      >
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">Conditions</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <devConditions :conditions="schema[mode].conditions" />
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="v-expansion-panel__clean">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === 2" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3"
                        >Attributes {{ mode }}</span
                      >
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">Attributes</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <devAttributesByPageMode v-if="renderPageMode" :mode="mode" :modes="modes" />
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="v-expansion-panel__clean">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span class="text-subtitle-2 font-weight-regular grey--text text--darken-3">Ordenação</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-row align="center" justify="center">
                      <v-col sm="4" md="4" lg="4">
                        <v-text-field label="Ordem" v-model="orderByFieldView" dense hide-details type="number" min="0" @input="orderByFields" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="v-expansion-panel__clean" v-if="mode === 'list'">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === 4" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3">Headers {{ mode }}</span>
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">Headers</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card class="px-2 py-2" flat tile>
                      <devContainerOfPanel
                        :schema="{
                          type: 'devContainerOfPanel',
                          model: 'headers',
                          component: 'dev-array-objects-attr',
                          styleClasses: 'col-12',
                          title: 'Headers',
                          objectRequired: ['text', 'value', 'align', 'sortable', 'width', 'visible']
                        }"
                        :model="{ headers: schema[mode].headers }"
                      />
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel v-if="mode === 'list' && modes.filter(mode => mode !== 'list').length" class="v-expansion-panel__clean">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === 5" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3">Child {{ mode }}</span>
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">Child</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card class="px-2 py-2" flat tile>
                      <v-row no-gutters class="mt-0">
                        <v-col cols="4">
                          <v-switch v-model="child" label="Child" dense class="mt-0" hide-details @change="handleToggleChildMode" />
                        </v-col>

                        <template v-if="child">
                          <v-col cols="8">
                            <v-select
                              :items="modes.filter(mode => mode !== 'list')"
                              v-model="childMode"
                              label="mode"
                              hide-details
                              dense
                              append-icon="zmdi zmdi-chevron-down"
                              @change="handleRealoadMode('list')"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-switch v-model="schema[mode].child.setAutomatically" label="setAutomatically" class="mr-1 mt-3" dense hide-details />
                          </v-col>

                          <v-col cols="6">
                            <v-switch v-model="schema[mode].child.useParentModel" label="useParentModel" class="ml-1 mt-3" dense hide-details />
                          </v-col>
                        </template>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="v-expansion-panel__clean" v-if="mode === 'list'">
                  <v-expansion-panel-header>
                    <v-fade-transition leave-absolute>
                      <span v-if="panel === 6" class="my-auto text-subtitle-2 font-weight-medium grey--text text--darken-3">recordActionsModel</span>
                      <span v-else class="text-subtitle-2 font-weight-regular grey--text text--darken-3">recordActionsModel</span>
                    </v-fade-transition>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card class="px-2 py-2" flat tile>
                      <devActionsAttr
                        :schema="{
                          type: 'devActionsAttr',
                          model: 'recordActionsModel',
                          styleClasses: 'col-12',
                          title: 'recordActionsModel'
                        }"
                        :model="{ recordActionsModel: schema[mode].recordActionsModel }"
                        :value="schema[mode].recordActionsModel"
                      />
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-tab-item>
          </v-tabs-items>
        </v-navigation-drawer>

        <v-dialog v-model="showDialogPage" persistent max-width="400px">
          <v-card>
            <v-card-title class="px-4 d-flex justify-space-between">
              <span class="text-subtitle-1 font-weight-medium">Defina o nome do arquivo</span>
              <v-icon color="grey darken-3" :size="20" @click="closeConfirmDialog">close</v-icon>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="mt-6 px-4">
              <v-text-field v-model="selectedPage" @input="handleDisableSave" label="Nome" type="text" required hide-details dense />
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn color="grey darken-3" :dark="!disableSave" :disabled="disableSave" @click="handleSavePage">Salvar</v-btn>

              <v-btn color="error" @click="closeConfirmDialog">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmPageChanges.dialog" persistent max-width="400px">
          <v-card>
            <v-card-title class="px-4 d-flex justify-space-between">
              <v-spacer />
              <v-icon color="grey darken-3" :size="20" @click="confirmPageChanges = { dialog: false, origin: '', fileName: '' }">close</v-icon>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="mt-4 px-4">
              <span class="text-subtitle-1 font-weight-medium">Você tem alterações, deseja salvar?</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn color="grey darken-3" dark @click="confirmSaveInFolder">Salvar</v-btn>
              <v-btn color="error" @click="discartChanges">Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-container>
</template>

<script>
import { savePage, getPageByName } from '@/services/dev';
import { randomString, addMandatoryParameters } from '@/helpers/dev';
import { MODE_LIST, OTHERS_MODES } from '@/helpers/dev/modeComponents';
import { INITIAL_SCHEMA } from '@/helpers/dev';
import * as SCHEME_COMPONENTS from '@/helpers/dev/schemeComponents';
import * as HANDLERS from '@/helpers/types/handlers';
import { sleep } from '@/helpers/page';
import eventBus from 'vue-option-events';

export default {
  components: {
    i4proForm: () => import('@/components/layouts/i4pro-form'),
    i4proList: () => import('@/components/layouts/i4pro-list'),
    devConditions: () => import('@/components/dev/dev-conditions'),
    devAttributesByPageMode: () => import('@/components/dev/dev-attr-by-page-mode'),
    devContainerOfPanel: () => import('@/components/dev/dev-container-of-panel'),
    devActionsAttr: () => import('@/components/dev/dev-actions-attr'),
    devLeftSidebar: () => import('@/components/dev/dev-left-sidebar')
  },

  data() {
    return {
      drawer2: null,
      renderComponent: true,
      selectedComponent: false,
      mode: null,
      drawer: true,
      tab: null,
      panel: '',
      accordions: [],
      child: false,
      childMode: null,
      orderByFieldView: 0,
      showDialogPage: false,
      disableSave: true,
      disableActionClone: true,
      disableActionRemove: true,
      renderPageMode: true,
      dialogPreview: false,
      previewVisible: false,
      leftDrawerWidth: '100%',
      rightDrawerWidth: '0%',
      previewSize: '100%',
      previewLayoutClass: ''
    };
  },

  created() {
    if (this.modes.length) {
      this.mode = this.modes[0];

      this.$store.dispatch('dev/setCurrentMode', this.mode);
    }

    this.accordions = this.mode === 'list' ? MODE_LIST : OTHERS_MODES;

    if ('list' in this.schema && 'child' in this.schema.list) this.child = true;
  },

  computed: {
    schema() {
      return this.$store.getters['dev/getSchema'];
    },

    modes() {
      let modes = this.$store.getters['dev/getModes'];

      this.mode = modes.length && modes[0];

      return modes;
    },

    getSelectedTab() {
      return this.$store.getters['dev/getSelectedTab'] + 1;
    },

    getActiveTab() {
      return this.$store.getters['dev/getActiveTab'];
    },

    currentComponent: function() {
      return this.mode === 'list' ? 'i4proList' : 'i4proForm';
    },

    background() {
      return this.schema.background.desktopImage
        ? `background-image: url('static/animais.png'); background-size: cover; background-position: top center;`
        : `background-color: ${this.schema.background.desktopColor}`;
    },

    typeOfPageEditing() {
      return this.$store.getters['dev/getTypeOfPageEditing'];
    },

    selectedEnvironment() {
      return this.$store.getters['dev/getSelectedEnvironment'];
    },

    selectedPortal() {
      return this.$store.getters['dev/getSelectedPortal'];
    },

    confirmPageChanges: {
      get() {
        return this.$store.getters['dev/getConfirmPageChanges'];
      },

      set(val) {
        this.$store.dispatch('dev/setConfirmPageChanges', val);
      }
    },

    selectedPage: {
      get() {
        let getSelectedPage = this.$store.getters['dev/getSelectedPage'];

        if (getSelectedPage !== '') {
          this.disableSave = false;
          this.leftDrawerWidth = '72.5%';
          this.rightDrawerWidth = '27.5%';
        } else {
          this.leftDrawerWidth = '100%';
          this.rightDrawerWidth = '0%';
        }

        return getSelectedPage;
      },

      set(val) {
        this.$store.dispatch('dev/setSelectedPage', val);
      }
    }
  },

  events: {
    [HANDLERS.RELOAD_COMPONENT_DEV]: 'reloadComponent',
    [HANDLERS.SELECT_COMPONENT_DEV]: 'selectComponent'
  },

  methods: {
    async discartChanges() {
      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setTypeOfPageEditing', '');
      this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));

      if (this.confirmPageChanges.origin === 'header') {
        this.$store.dispatch('dev/setCurrentTemplate', 'templateHome');
      }

      if (this.confirmPageChanges.origin === 'edit') {
        const { data: schema } = await getPageByName(this.selectedPortal.portalId, this.confirmPageChanges.fileName);

        await this.$store.dispatch('dev/setSchema', addMandatoryParameters(schema));

        await this.$store.dispatch('page/load', { page: 'dev', mode: this.modes[0] });

        this.$store.dispatch('dev/setCurrentMode', this.modes[0]);
        this.$store.dispatch('dev/setSelectedPage', this.confirmPageChanges.fileName);
        this.$store.dispatch('dev/setTypeOfPageEditing', 'edit');

        this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(addMandatoryParameters(schema))));
      }

      if (this.confirmPageChanges.origin === 'new') {
        this.$store.dispatch('dev/setTypeOfPageEditing', 'new');
      }

      this.confirmPageChanges = { dialog: false, origin: '', fileName: '' };
    },

    updateColorTheme(color) {
      if (this.jsonUpload.theme[color].length > 0) {
        this.$vuetify.theme.themes.light[color] = this.jsonUpload.theme[color];
      }
    },

    // --> Reload na page (necessário para atualizar alguns componentes)!
    async reloadComponent(model) {
      this.renderComponent = false;

      model && this.$store.dispatch('dev/setSelected', model);

      this.$nextTick(() => (this.renderComponent = true));

      if (model && model.type === 'i4proTabs' && this.getActiveTab) {
        const getActiveTab = this.getActiveTab;
        await sleep(600);
        eventBus.$emit('CHANGE_ACTIVE_TAB', getActiveTab - 1);
      }
    },

    handleRealoadMode() {
      this.schema['list'].child.mode = this.childMode;

      this.reloadComponent();
    },

    changeOrder(schemaItem, index, copy) {
      schemaItem.splice(index, 1);
      schemaItem.splice(this.orderByFieldView, 0, copy);
    },

    // --> Adiciona um componente de grupo de coluna!
    handleAddColumnGroup(current) {
      this.schema[this.mode].groups.push(current.models);

      this.selectedComponent = current;

      this.reloadComponent(current.models);
    },

    // --> Adiciona um componente de action!
    handleAddActions(current, selectedItem) {
      if (selectedItem.type === 'i4proTabs') {
        if ('page' in selectedItem.content[this.getSelectedTab]) {
          this.$store.dispatch('notification/showNotification', {
            color: 'warning',
            text: `Essa tab renderiza outra página, não é possível adicionar uma action!`,
            showIconNotification: false
          });

          return;
        }

        this.schema[this.mode].tabs.content[this.getSelectedTab].actions = current.models;

        this.reloadComponent();

        return;
      }

      this.schema[this.mode].actions = current.models;

      this.selectedComponent = current;

      this.reloadComponent(current.models);
    },

    // --> Comment here
    orderByFields() {
      if (this.selectedComponent && this.orderByFieldView >= 0) {
        const item = this.selectedComponent.models.model;
        let copySelect = {};
        let schemaListCurrent = '';
        let indexSchema = 0;
        let orderBy = false;

        // --> move os fields da raiz
        const fields = this.schema[this.mode].fields;

        if (fields.length > 0) {
          fields.forEach((itemSchema, index) => {
            if (itemSchema.model == item) {
              this.changeOrder(fields, index, itemSchema);

              orderBy = true;
              return;
            }
          });
        }

        // --> move os Fields dentro da master
        const masterFields = this.schema[this.mode].master ? this.schema[this.mode].master.fields : null;

        if (masterFields && !orderBy) {
          masterFields.forEach((itemSchema, index) => {
            if (itemSchema.model == item) {
              this.changeOrder(masterFields, index, itemSchema);

              orderBy = true;
              return;
            }
          });
        }

        const groups = this.schema[this.mode].groups;

        // --> Move os Fiels dentro de groups
        if (groups.length > 0 && !orderBy) {
          groups.forEach((groupItem, indexGroup) => {
            groupItem.fields.forEach((itemSchema, index) => {
              if (itemSchema.model == item) {
                this.changeOrder(groups[indexGroup].fields, index, itemSchema);

                orderBy = true;
                return;
              }
            });
          });

          // --> Move os groups
          if (!orderBy) {
            groups.forEach((itemSchema, indexGroup) => {
              if (itemSchema.model == item) {
                this.changeOrder(groups, indexGroup, itemSchema);

                orderBy = true;
                return;
              }
            });
          }
        }

        if (this.schema[this.mode].tabs && !orderBy) {
          const tabsFields = this.schema[this.mode].tabs.content[this.getActiveTab].fields;

          // --> Move os Fields dentro de tabs
          tabsFields.forEach((itemSchema, index) => {
            if (itemSchema.model == item) {
              this.changeOrder(tabsFields, index, itemSchema);

              orderBy = true;
              return;
            }
          });

          if (!orderBy) {
            const tabsGroups = this.schema[this.mode].tabs.content[this.getActiveTab].groups;

            // --> Move os groups dentro de tabs
            tabsGroups.forEach((itemSchema, index) => {
              if (itemSchema.model == item) {
                this.changeOrder(tabsGroups, index, itemSchema);

                orderBy = true;
                return;
              }

              if (!orderBy) {
                const pathTabsGroupFields = this.schema[this.mode].tabs.content[this.getActiveTab].groups[index].fields;

                // --> Move os Fields dentro de tabs dentro de tabs
                pathTabsGroupFields.forEach((itemSchemaFields, indexField) => {
                  if (itemSchemaFields.model == item) {
                    this.changeOrder(pathTabsGroupFields, indexField, itemSchemaFields);

                    return;
                  }
                });
              }
            });
          }
        }

        this.reloadComponent();
      }
    },

    openPreview(param) {
      this.previewVisible = true;
      this.leftDrawerWidth = '100%';
      this.rightDrawerWidth = '0%';
    },

    closePreview() {
      this.previewVisible = false;
      this.leftDrawerWidth = '72.5%';
      this.rightDrawerWidth = '27.5%';
      this.previewSize = '100%';
      this.previewLayoutClass = '';
    },

    changePreview(type) {
      if (type === 'mobile') {
        this.previewSize = '360px';
        this.previewLayoutClass = 'content-mobile';
      }

      if (type === 'tablet') {
        this.previewSize = '960px';
        this.previewLayoutClass = 'content-tablet';
      }

      if (type === 'desktop') {
        this.previewSize = '100%';
        this.previewLayoutClass = '';
      }
    },

    // --> Regras para clonar o componente selecionado! ---------------------------------------------------------------------------------------
    clone() {
      const selectedComponent = this.selectedComponent;

      // --> Ignora componentes que não podem ser clonados!
      if (
        selectedComponent.models.type === 'i4proTabs' ||
        selectedComponent.models.type === 'i4proDetailDrawer' ||
        selectedComponent.models.type === 'i4proDetailPage'
      ) {
        this.$store.dispatch('notification/showNotification', {
          color: 'warning',
          text: `${selectedComponent.models.type} não pode ser clonado!`,
          showIconNotification: false
        });

        return;
      }

      let currentMode = this.schema[this.mode];
      let wasCloned = false;
      let clone = JSON.parse(JSON.stringify(selectedComponent));
      clone.models.model = randomString();
      clone.models.id = clone.models.model;

      // --> Clona um componente dentro do grupo de coluna!
      if (!wasCloned) {
        currentMode.groups.forEach(group => {
          group.fields.forEach(field => {
            if (field.model === selectedComponent.models.model) {
              group.fields.push(clone.models);

              wasCloned = true;

              return;
            }
          });
        });
      }

      // --> Clona um componente dentro da master detail!
      if (!wasCloned && 'master' in currentMode && Object.keys(currentMode.master).length) {
        currentMode.master.fields.forEach(field => {
          if (field.model === selectedComponent.models.model) {
            currentMode.master.fields.push(clone.models);

            wasCloned = true;

            return;
          }
        });
      }

      // --> Clona um componente dentro TAB ativa!
      if (!wasCloned && 'tabs' in currentMode) {
        const activeTab = this.getActiveTab;

        // --> Procura dentro dos fields da TAB ativa!
        currentMode.tabs.content[activeTab].fields.forEach(field => {
          if (field.model === selectedComponent.models.model) {
            currentMode.tabs.content[activeTab].fields.push(clone.models);

            wasCloned = true;

            return;
          }
        });

        // --> Procura grupo de coluna dentro da TAB ativa!
        !wasCloned &&
          currentMode.tabs.content[activeTab].groups.forEach(group => {
            if (group.model === selectedComponent.models.model) {
              clone.models.fields.forEach(field => {
                field.model = randomString();
                field.id = field.model;
              });

              currentMode.tabs.content[activeTab].groups.push(clone.models);

              wasCloned = true;

              return;
            }
          });

        !wasCloned &&
          currentMode.tabs.content[activeTab].groups.forEach(group => {
            group.fields.forEach(field => {
              if (field.model === selectedComponent.models.model) {
                group.fields.push(clone.models);

                wasCloned = true;

                return;
              }
            });
          });
      }

      // --> Clona um grupo de coluna!
      if (!wasCloned && selectedComponent.models.type === 'i4proColumnGroup') {
        clone.models.fields.forEach(field => {
          field.model = randomString();
          field.id = field.model;
        });

        currentMode.groups.push(clone.models);

        this.reloadComponent(clone.models);

        wasCloned = true;

        return;
      }

      // --> Clona um componente dentro dos fields!
      !wasCloned && currentMode.fields.push(clone.models);

      this.reloadComponent(clone.models);
    },

    // --> Regras para remover componente selecionado! ---------------------------------------------------------------------------------------
    remove() {
      let componentFound = false;
      let currentMode = this.schema[this.mode];

      // --> Remove um componente em fields!
      currentMode.fields.map((field, index) => {
        if (field.model === this.selectedComponent.models.model) {
          currentMode.fields.splice(index, 1);

          componentFound = true;
        }
      });

      // --> Remove um grupo de coluna!
      if (!componentFound) {
        currentMode.groups.map((group, index) => {
          if (group.model === this.selectedComponent.models.model) {
            currentMode.groups.splice(index, 1);

            componentFound = true;
          }
        });
      }

      // --> Remove um componente em grupo de coluna!
      if (!componentFound) {
        currentMode.groups.map((group, i) => {
          group.fields.map((field, index) => {
            if (field.model === this.selectedComponent.models.model) {
              currentMode.groups[i].fields.splice(index, 1);

              componentFound = true;
            }
          });
        });
      }

      // --> Remove as action
      if (!componentFound) {
        if (currentMode.actions.model == this.selectedComponent.models.model) {
          currentMode.actions = {};

          componentFound = true;
        }
      }

      // --> Remove um componente da master detail!
      if (!componentFound && 'master' in currentMode && Object.keys(currentMode.master).length) {
        currentMode.master.fields.map((field, index) => {
          if (field.model === this.selectedComponent.models.model) {
            currentMode.master.fields.splice(index, 1);

            componentFound = true;
          }
        });
      }

      // --> Remove um componente dentro de tabs!
      if (!componentFound && 'tabs' in currentMode) {
        // --> Remove um componente dentro dos fields das tabs!
        currentMode.tabs.content[this.getActiveTab].fields.map((field, index) => {
          if (field.model === this.selectedComponent.models.model) {
            currentMode.tabs.content[this.getActiveTab].fields.splice(index, 1);

            componentFound = true;
          }
        });

        // --> Remove um grupo de coluna!
        !componentFound &&
          currentMode.tabs.content[this.getActiveTab].groups.map((group, index) => {
            if (group.model === this.selectedComponent.models.model) {
              currentMode.tabs.content[this.getActiveTab].groups.splice(index, 1);

              componentFound = true;
            }
          });

        // --> Remove um componente dentro dos grupos de coluna, fields das tabs!
        !componentFound &&
          currentMode.tabs.content[this.getActiveTab].groups.map((group, index) => {
            group.fields.map((field, i) => {
              if (field.model === this.selectedComponent.models.model) {
                currentMode.tabs.content[this.getActiveTab].groups[index].fields.splice(i, 1);
              }
            });
          });

        // --> Remove actions dentro das tabs!
        if (
          !componentFound &&
          (this.selectedComponent.models.type === 'i4proButton' ||
            this.selectedComponent.models.type === 'i4proFloatingActionButtons' ||
            this.selectedComponent.models.type === 'i4proFabTransition')
        ) {
          currentMode.tabs.content[this.getActiveTab].actions = {};
        }
      }

      // --> Remove a tela master detail!
      if (!componentFound && 'master' in currentMode && currentMode.master.model === this.selectedComponent.models.model) {
        currentMode.master = {};

        // --> Remove tabs quando master detail é removido!
        if ('tabs' in this.schema[this.mode]) delete this.schema[this.mode].tabs;

        componentFound = true;
      }

      if (!componentFound && this.selectedComponent.models.type === 'i4proTabs') {
        delete this.schema[this.mode].tabs;

        componentFound = true;
      }

      if (componentFound) this.reloadComponent();

      this.$store.dispatch('dev/setSelected', {});
      this.selectedComponent = false;
      this.tab = 'tab-1';
    },

    // --> Regras para selecionar um componente! ---------------------------------------------------------------------------------------
    selectComponent(component) {
      let current = '';
      let currentMode = this.schema[this.mode];

      try {
        // --> Seleciona um componente dentro dos fields!
        'fields' in currentMode &&
          currentMode.fields.map((field, index) => {
            if (field.model === component) {
              current = field;

              this.orderByFieldView = index;
            }
          });

        // --> Seleciona uma action!
        if (currentMode.actions.model === component) current = currentMode.actions;

        // --> Seleciona um componente dentro de um grupo de coluna!
        if (current === '' && currentMode.groups.length) {
          currentMode.groups.map(group => {
            group.fields.map((field, index) => {
              if (field.model === component) {
                current = field;

                this.orderByFieldView = index;
              }
            });
          });
        }

        // --> Seleciona um grupo de coluna!
        if (current === '') {
          currentMode.groups.map((group, index) => {
            if (group.model === component) {
              current = group;

              this.orderByFieldView = index;
            }
          });
        }

        // --> Seleciona um componente dentro de um determinado step!
        if (current === '' && currentMode.steps) {
          currentMode.steps.content[1].fields.map((field, index) => {
            field.model === component && (current = field);
          });
        }

        // --> Seleciona um step!
        if (current === '' && currentMode.steps && currentMode.steps.model === component) {
          current = currentMode.steps;
          current.type = currentMode.steps.attributes.name; // --> Colocar type no step!
        }

        // --> Seleciona o componente master detail!
        if (current === '' && currentMode.master.model === component) current = currentMode.master;

        // --> Seleciona um componente dentro da master detail!
        if (current === '' && 'fields' in currentMode.master) {
          currentMode.master.fields.map((field, index) => {
            if (field.model === component) {
              current = field;

              this.orderByFieldView = index;
            }
          });
        }

        // --> Seleciona componente de tabs!
        if (current === '' && 'tabs' in currentMode && currentMode.tabs.model === component) current = currentMode.tabs;

        // --> Seleciona um componente dentro de tabs!
        if (current === '' && 'tabs' in currentMode) {
          // --> Procura um componente dentro dos fields das tabs!
          currentMode.tabs.content[this.getActiveTab].fields.map((field, index) => {
            if (field.model === component) {
              current = field;

              this.orderByFieldView = index;
            }
          });

          // --> Procura um grupo de coluna para seleção!
          current === '' &&
            currentMode.tabs.content[this.getActiveTab].groups.map((group, index) => {
              if (group.model === component) {
                current = group;

                this.orderByFieldView = index;
              }
            });

          // --> Procura um componente dentro dos grupos de coluna, fields das tabs!
          current === '' &&
            currentMode.tabs.content[this.getActiveTab].groups.map(group => {
              group.fields.length &&
                group.fields.map((field, index) => {
                  if (field.model === component) {
                    current = field;

                    this.orderByFieldView = index;
                  }
                });
            });

          // --> Procura uma action dentro das tabs!
          if (current === '' && currentMode.tabs.content[this.getActiveTab].actions.model === component) {
            current = currentMode.tabs.content[this.getActiveTab].actions;
          }
        }
      } catch (_err) {
        this.$store.dispatch('notification/showNotification', {
          color: 'warning',
          text: _err,
          showIconNotification: false
        });
      }

      if (current === '') return;

      let selectedComponentTemp = JSON.parse(JSON.stringify(SCHEME_COMPONENTS.default[current.type]));

      selectedComponentTemp.models = current;

      this.selectedComponent = selectedComponentTemp;

      this.$store.dispatch('dev/setSelected', current);

      this.tab = 'tab-2';
    },

    // --> Regras para renderizar um componente! ---------------------------------------------------------------------------------------
    handleRenderComponent(item) {
      let current = JSON.parse(JSON.stringify(SCHEME_COMPONENTS.default[item.type]));
      let currentMode = this.schema[this.mode];
      let selectedItem = this.$store.getters['dev/getSelected'];

      // --> Gera uma model randômica!
      current.models.model = randomString();

      if (item.type === 'i4proButtonLink') {
        current.models.id = randomString();
        current.models.name = randomString();
      }

      if (
        item.type === 'i4proGroupButtons' ||
        item.type === 'i4proFabTransition' ||
        item.type === 'i4proButton' ||
        item.type === 'i4proFloatingActionButtons'
      ) {
        current.models.items.forEach(item => {
          item.id = randomString();
          item.name = randomString();
          item.actionName = `${this.mode}-${current.models.model}`;
        });
      }

      if ('typeLookup' in current.models && current.models.type == 'i4proTableDetail') {
        this.$store.dispatch('page/load', { page: 'dev', mode: this.mode });
      }

      // --> Regras para renderizar tela master!
      if (item.type === 'i4proDetailPage' || item.type === 'i4proDetailDrawer') {
        currentMode.master = current.models;

        this.selectedComponent = current;

        this.reloadComponent(current.models);

        return;
      }

      // --> Regras para renderizar tabs!
      if (item.type === 'i4proTabs') {
        if ('master' in this.schema[this.mode] && !Object.keys(this.schema[this.mode].master).length) {
          this.$store.dispatch('notification/showNotification', {
            color: 'warning',
            text: 'Para utilizar tabs é necessário ter um Detail(master)!',
            showIconNotification: false
          });

          return;
        }

        current.models.headers.forEach((header, index) => {
          header.tabName = `${this.mode}-${index + 1}`;
        });

        currentMode.tabs = current.models;

        this.selectedComponent = current;

        this.reloadComponent(current.models);

        return;
      }

      // --> Concatena modo de tela com model randômica (regras de permissão)!
      current.models.fieldName = `${this.mode}-${current.models.model}`;

      // --> Renderiza um Grupo de coluna dentro de "i4proTabs"!
      if (selectedItem.type === 'i4proTabs' && item.type === 'i4proColumnGroup') {
        if ('page' in selectedItem.content[this.getSelectedTab]) {
          this.$store.dispatch('notification/showNotification', {
            color: 'warning',
            text: `Essa tab renderiza outra página, não é possível adicionar um grupo de coluna!`,
            showIconNotification: false
          });

          return;
        }

        selectedItem.content[this.getSelectedTab].groups.push(current.models);

        return;
      }

      // --> Regras para renderizar o Column group!
      if (item.type === 'i4proColumnGroup') {
        current.models.id = current.models.model;

        this.handleAddColumnGroup(current);

        return;
      }

      // --> Regras para renderizar Actions!
      if (item.type === 'i4proFabTransition' || item.type === 'i4proButton' || item.type === 'i4proFloatingActionButtons') {
        this.handleAddActions(current, selectedItem);

        return;
      }

      // --> Renderiza um componente dentro do nó fields de "i4proTabs"!
      if (selectedItem.type === 'i4proTabs') {
        if ('page' in selectedItem.content[this.getSelectedTab]) {
          this.$store.dispatch('notification/showNotification', {
            color: 'warning',
            text: `Essa tab renderiza outra página, não é possível adicionar um componente!`,
            showIconNotification: false
          });

          return;
        }

        selectedItem.content[this.getSelectedTab].fields.push(current.models);

        current.models.fieldName = `${this.mode}-${this.getSelectedTab}-${current.models.model}`;

        return;
      }

      // --> Regras para renderizar Componente dentro do grupo de coluna!
      if (selectedItem.type === 'i4proColumnGroup') {
        let wasFound = false;

        // --> Direto no grupo de coluna!
        currentMode.groups.map((group, index) => {
          if (group.model === selectedItem.model) {
            currentMode.groups[index].fields.push(current.models);

            wasFound = true;
          }
        });

        if (wasFound) return;

        // --> Grupo de coluna dentro de tabs!
        currentMode.tabs.content[this.getActiveTab].groups.map((group, index) => {
          if (group.model === selectedItem.model) {
            currentMode.tabs.content[this.getActiveTab].groups[index].fields.push(current.models);
          }
        });

        return;
      }

      // --> Regras para renderizar Componente dentro da master detail(fields)!
      if (selectedItem.type === 'i4proDetailDrawer' || selectedItem.type === 'i4proDetailPage') {
        currentMode.master.fields.push(current.models);

        this.selectedComponent = current;

        this.reloadComponent(current.models);

        return;
      }

      this.selectedComponent = current;

      currentMode.fields.push(current.models);

      this.mode === 'list' && this.$store.dispatch('page/executePageEvents');

      this.reloadComponent(current.models);
    },

    // --> Regras para desselecionar um componente! ---------------------------------------------------------------------------------------
    unselectComponent(e) {
      e.preventDefault();

      if (
        e.target.className === 'v-navigation-drawer__content' &&
        e.target.offsetParent.className.includes('dev-step-two-v-navigation-drawer-left') &&
        this.selectedComponent
      ) {
        this.$store.dispatch('dev/setSelected', {});

        this.selectedComponent.models.type === 'i4proTabs' && this.$store.dispatch('dev/setSelectedTab', null);

        this.tab === 'tab-2' && (this.tab = 'tab-1');
        this.selectedComponent = false;
      }
    },

    clearSchemaBeforeSave(schema) {
      if ('list' in schema) {
        delete schema.list.procedure.model;

        schema.list.lookups = {};

        schema.list.fields.forEach(field => {
          if (field.type === 'i4proSelect' && field.procedure.name.length) {
            field.attributesSelect.items = [];
          }
        });

        'groups' in schema.list &&
          schema.list.groups.forEach(group => {
            group.fields.forEach(field => {
              if (field.type === 'i4proSelect' && field.procedure.name.length) {
                field.attributesSelect.items = [];
              }
            });
          });
      }

      this.modes
        .filter(mode => mode !== 'list')
        .forEach(mode => {
          delete schema[mode].procedure.model;

          schema[mode].fields.forEach(field => {
            if (field.type === 'i4proSelect' && field.procedure.name.length) {
              field.attributesSelect.items = [];
            }
          });

          schema[mode].groups.forEach(group => {
            group.fields.forEach(field => {
              if (field.type === 'i4proSelect' && field.procedure.name.length) {
                field.attributesSelect.items = [];
              }
            });
          });

          if ('master' in schema[mode] && Object.keys(schema[mode].master).length) {
            'fields' in schema[mode].master &&
              schema[mode].master.fields.forEach(field => {
                if (field.type === 'i4proSelect' && field.procedure.name.length) {
                  field.attributesSelect.items = [];
                }
              });
          }

          'tabs' in schema[mode] &&
            Object.values(schema[mode].tabs.content).map(content => {
              content.fields.forEach(field => {
                if (field.type === 'i4proSelect' && field.procedure.name.length) {
                  field.attributesSelect.items = [];
                }
              });

              content.groups.forEach(group => {
                group.fields.forEach(field => {
                  if (field.type === 'i4proSelect' && field.procedure.name.length) {
                    field.attributesSelect.items = [];
                  }
                });
              });
            });
        });

      return schema;
    },

    // --> Salva na pasta especificada no server -------------------------------------------------------------------------------
    confirmSaveInFolder() {
      this.confirmPageChanges = { dialog: false, origin: '', fileName: '' };
      this.showDialogPage = true;
      this.disableSave = false;
    },

    closeConfirmDialog() {
      this.showDialogPage = false;
      this.disableSave = true;
    },

    async handleSavePage() {
      const schema = this.clearSchemaBeforeSave(JSON.parse(JSON.stringify(this.schema)));

      try {
        await savePage(this.selectedPortal.portalId, JSON.stringify(schema), this.selectedPage);

        this.$store.dispatch('dev/setSchema');
        this.$store.dispatch('dev/setSelectedPage', '');
        this.$store.dispatch('dev/setTypeOfPageEditing', '');
        this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));

        this.closeConfirmDialog();

        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: `Arquivo salvo com sucesso!`,
          showIconNotification: false
        });
      } catch (err) {
        this.$store.dispatch('notification/showNotification', {
          color: 'error',
          text: `Ocorreu um erro ao salvar o arquivo`,
          showIconNotification: true
        });
      }
    },

    handleDisableSave() {
      this.selectedPage.length >= 3 ? (this.disableSave = false) : (this.disableSave = true);
    },

    // --> Alterna os child nos modo list! ---------------------------------------------------------------------------------------
    handleToggleChildMode() {
      if (!this.child) delete this.schema.list.child;

      if (this.child) {
        this.schema.list.child = {
          mode: this.modes.filter(mode => mode !== 'list')[0],
          setAutomatically: false,
          useParentModel: false
        };

        this.childMode = this.modes.filter(mode => mode !== 'list')[0];
      }

      this.reloadComponent();
    },

    // --> Alterna os modos de tela! ---------------------------------------------------------------------------------------
    async changeModes() {
      await this.$store.dispatch('page/load', { page: 'dev', mode: this.mode });

      this.accordions = this.mode === 'list' ? MODE_LIST : OTHERS_MODES;

      // --> Retorna para tab-1 e limpa se houver algum componente selecionado!
      this.$store.dispatch('dev/setSelected', {});

      this.$store.dispatch('dev/setCurrentMode', this.mode);

      this.tab = 'tab-1';
      this.selectedComponent = false;
    }
  },

  watch: {
    selectedComponent: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (!newValue) {
          this.disableActionClone = true;
          this.disableActionRemove = true;

          // --> Alterna os btns clone/remove (quando um componente é selecionado)!
          // this.actions.forEach(action => {
          //   action.name.toLowerCase() === 'clone' && (action.disabled = true);
          //   action.name.toLowerCase() === 'remove' && (action.disabled = true);
          // });
        }

        if (newValue) {
          this.disableActionClone = false;
          this.disableActionRemove = false;

          // --> Alterna os btns clone/remove (quando um componente é selecionado)!
          // this.actions.forEach(action => {
          //   action.name.toLowerCase() === 'clone' && (action.disabled = false);
          //   action.name.toLowerCase() === 'remove' && (action.disabled = false);
          // });

          // --> Alterna field "typeLookup" se a procedure for preenchida!
          if ('procedure' in newValue.models && newValue.models.procedure.name.length) {
            newValue.fields.map(field => {
              field.model === 'typeLookup' && (field.visible = true);

              if (newValue.models.type === 'i4proSelect' && field.model === 'attributesSelect.items') field.visible = false;
            });
          } else {
            newValue.fields.map(field => {
              field.model === 'typeLookup' && (field.visible = false);

              if (newValue.models.type === 'i4proSelect' && field.model === 'attributesSelect.items') field.visible = true;
            });

            delete newValue.models.procedure;
            delete newValue.models.typeLookup;
          }

          // --> Mantém "fieldName" atualizado com a model!
          if ('fieldName' in newValue.models) {
            newValue.models.fieldName = `${this.mode}-${newValue.models.model}`;
          }

          // --> Mantém "actionName" atualizado com a model!
          if (newValue.models.actions || newValue.models.items) {
            let list = [];

            if (newValue.models.items) list = newValue.models.items;

            if (newValue.models.actions && newValue.models.actions.items) {
              list = newValue.models.actions.items;
            } else {
              list = newValue.models.actions;
            }
          }

          // --> Alterna campo mínimo "min" nas validação(rules)!
          if ('rules' in newValue.models && !newValue.models.rules.includes('min')) {
            newValue.fields.forEach((field, index) => {
              field.model === 'min' && (newValue.fields[index].visible = false);
            });
          } else {
            newValue.fields.forEach((field, index) => {
              field.model === 'min' && (newValue.fields[index].visible = true);
            });
          }

          // --> Alterna campo máximo "max" nas validação(rules)!
          if ('rules' in newValue.models && !newValue.models.rules.includes('max')) {
            newValue.fields.forEach((field, index) => {
              field.model === 'max' && (newValue.fields[index].visible = false);
            });
          } else {
            newValue.fields.forEach((field, index) => {
              field.model === 'max' && (newValue.fields[index].visible = true);
            });
          }

          // --> Valida se existe formatação do tipo decimal no componente!
          if (newValue.models.type === 'i4proTextField' && newValue.models.format === 'decimal') {
            let currentModel = newValue.fields.find(e => {
              return e.model === 'formatDecimal';
            });

            currentModel.visible = true;

            this.reloadComponent();
          }

          // --> Valida SE NÂO existe formatação do tipo decimal no componente!
          if (newValue.models.type === 'i4proTextField' && newValue.models.format !== 'decimal') {
            let teste = newValue.fields.find(e => e.model === 'formatDecimal');

            teste.visible = false;
            delete newValue.models.formatDecimal;

            this.reloadComponent();
          }

          if (
            newValue.models.type === 'i4proDetailDrawer' ||
            newValue.models.type === 'i4proDetailPage' ||
            newValue.models.type === 'i4proAutocomplete'
          ) {
            this.reloadComponent();
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.v-application {
  .dev-selected-component {
    border: 2px dashed rgba(62, 126, 230, 0.5) !important;
    border-radius: 4px;
    padding: 4px;
    transition: all ease-in-out 0.3s;
  }

  .dev-selected-component__no-change-padding {
    border: 2px dashed rgba(62, 126, 230, 0.5) !important;
    border-radius: 4px;
    transition: all ease-in-out 0.3s;
  }
}

// --> Remove espaçamento do i4proButtonLink
.vue-form-generator .form-group[class*='col-'].field-i4proButtonLink {
  padding-top: 0;
  padding-bottom: 0;
  position: absolute;
}

.v-menu__content {
  background: #fff;
}
</style>
